// extracted by mini-css-extract-plugin
module.exports = {"faq":"FAQ_faq__t8-16","faqquestion":"FAQ_faqquestion__34HkR","faqanswer":"FAQ_faqanswer__1Z_-C"};